import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  DepositQuoteRequestPayloadSchema,
  GetPaymentIntentDTO,
  PaymentIntentDTO,
  PaymentIntentPayloadSchema,
  QuoteDTO,
  RefundFlowType,
} from 'views/types';

const baseUrl = '/api/v1/';
// const baseUrl = 'https://payment.cryptopay-dev.space-app.io/api/v1/';
const tags = ['Deposit', 'PaymentGateway'];

export const depositApi = createApi({
  reducerPath: 'depositApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
  }),
  tagTypes: tags,
  endpoints: (builder) => ({
    postPaymentIntent: builder.mutation<
      PaymentIntentDTO,
      { paymentIntentData: PaymentIntentPayloadSchema } & { authToken: string }
    >({
      invalidatesTags: tags,
      query: ({ paymentIntentData, authToken }) => ({
        url: 'payment-intents',
        method: 'POST',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        body: paymentIntentData,
      }),
    }),
    getPaymentGateway: builder.query<GetPaymentIntentDTO, { authToken: string }>({
      providesTags: ['PaymentGateway'],
      // // For testing purposes only
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // transformResponse: (response: { paymentIntent: GetPaymentIntentDTO }) => ({
      //   ...response,
      //   billingInfoRequirement: 'Required',
      //   emailRequirement: 'None',
      // }),
      query: ({ authToken }) => ({
        url: 'payment-intents',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }),
    }),
    postPaymentIntentQuote: builder.mutation<
      QuoteDTO,
      { paymentIntentQuoteData: DepositQuoteRequestPayloadSchema } & { authToken: string }
    >({
      invalidatesTags: tags,
      query: ({ paymentIntentQuoteData, authToken }) => ({
        url: 'payment-intents/quote-request',
        method: 'POST',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        body: paymentIntentQuoteData,
      }),
    }),
    getCryptoRefundLink: builder.query<string, { authToken: string; refundFlow: RefundFlowType; languageIso2?: string }>({
      query: ({ authToken, refundFlow = 'Full', languageIso2 }) => ({
        url: `payment-intents/crypto-refunds/link?refundFlow=${refundFlow}${languageIso2 ? `&languageIso2=${languageIso2}` : ''}`,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }),
    }),
  }),
});

export const {
  usePostPaymentIntentMutation,
  usePostPaymentIntentQuoteMutation,
  useGetPaymentGatewayQuery,
  useGetCryptoRefundLinkQuery,
  useLazyGetCryptoRefundLinkQuery,
} = depositApi;
